import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {EmployeeCostDto} from "../models/employee-cost-dto";
import {ServerEndpoints} from "../server.endpoints";

@Injectable({
  providedIn: 'root'
})
export class EmployeeHttpService {

  constructor(private http: HttpClient, @Inject("BASE_URL") private baseUrl: string,
              @Inject('BASE_HEADERS') baseHeaders: HttpHeaders) {
  }

  getEmployeeCostsFromEvent(eventId: string): Observable<EmployeeCostDto[]> {
    return this.http.get<EmployeeCostDto[]>(this.baseUrl + ServerEndpoints.Company_EmploymentRelationship_GetEventEmploymentCosts + "?eventId=" + eventId);
  }

  getEmployeeCostsFromTimerange(start: string, end: string): Observable<{ [id: string]: EmployeeCostDto[] }> {
    return this.http.get<{
      [id: string]: EmployeeCostDto[]
    }>(this.baseUrl + ServerEndpoints.Company_EmploymentRelationship_GetEventsEmploymentCosts + "?startTime=" + start + "&endTime=" + end);
  }
}

